import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "15",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#171717",
      "fill-rule": "evenodd",
      d: "M11.333 8.833v-2.5c-3.466 0-4.858.367-6.666 3.334 0 0 .166-3.392 3.075-5 .9-.5 2.075-.834 3.591-.834v-2.5l4.167 3.75zm4.692-4.391L11.858.692a.82.82 0 0 0-.883-.109.82.82 0 0 0-.475.75v1.7c-1.192.092-2.167.384-2.967.8a6.2 6.2 0 0 0-1.241.834c-2.275 1.941-2.45 4.916-2.459 4.958a.84.84 0 0 0 .592.842.832.832 0 0 0 .95-.367C6.817 7.742 7.817 7.242 10.5 7.175v1.658c0 .325.183.617.475.75a.815.815 0 0 0 .883-.108l4.167-3.75a.81.81 0 0 0 .308-.642.81.81 0 0 0-.308-.641",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#171717",
      "fill-rule": "evenodd",
      d: "M13 13c0 .46-.374.834-.833.834h-10A.835.835 0 0 1 1.333 13V5.5c0-.459.375-.833.834-.833H5.11c.197-.216.402-.431.637-.632.085-.072.178-.133.266-.202H2.167C1.247 3.834.5 4.58.5 5.5V13c0 .92.747 1.667 1.667 1.667h10c.92 0 1.666-.747 1.666-1.667V8.818l-.833.75z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }